import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DynamicsLinkedService } from '../linkedservice/dynamics.linkedservice';
import { format } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.dynamics.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Dynamics_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Dynamics_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: DynamicsLinkedService.MODEL // Linked service redefined
        }
    }
})
export class DynamicsEntityDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
